<!--
 * @Author: gongzhichao
 * @Date: 2023-04-27 17:15:00
 * @LastEditors: gongzhichao 18311120024@163.com
 * @Description: 扫码下载页面
-->
<template>
  <div class="main">
    <div>敬请期待~</div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  metaInfo: {
    title: "《群侠传》官方网站_Q版千年武侠手游_值得期待的江湖世界",
    meta: [
      {
        name: "description",
        content:
          "《群侠传》是一款Q版千年武侠风格的即时战斗MMORPG游戏，自由探索、交易、战斗、结交各路英雄，能让你感觉到进入了一个充满江湖气息的世界！",
      },
      {
        name: "keywords",
        content:
          "群侠传,群侠传手游,群侠传官网,群侠传手游官网,千年三,千年手游,千年官网,千年手游官网,武林群侠传,九妖,九妖官网,九妖手游,九妖手游官网,千年三官网,千年盛世,千年盛世手游,千年盛世官网,千年游戏盒子,Q版武侠,开放世界手游,巴雄天下,剑雨如歌,侠众道,异侠传,异侠传手游,金庸群侠传,剑网三手游,仙剑世界,千年游戏,千年盒子",
      },
    ],
  },
  data() {
    return {
      url: "",
    };
  },
  created() {
    // this.downloadUrl();
  },
  methods: {
    ...mapActions({ getDownloadUrl: "base/getDownloadUrl" }),
    // 下载
    async downloadUrl() {
      let { anxUrl, iosUrl } = await this.getDownloadUrl();
      this.url = this.$utils.isMobileType() == "ios" ? iosUrl : anxUrl;
    },
    async download() {
      let url =
        this.$utils.isMobileType() == "ios"
          ? "https://wkzx.wang/RMj7"
          : "https://down.open1000y.com/jyrg.apk";
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: calc(100vh - 56px);
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  .wechat-browser {
    position: absolute;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.5);
    z-index: 999;
    .spin {
      position: absolute;
      top: 5%;
      right: 10%;
      width: 80px;
      height: 150px;
      -ms-transform: rotate(15deg); /* IE 9 */
      -webkit-transform: rotate(15deg); /* Safari and Chrome */
      transform: rotate(15deg);
    }
    .waring-mes {
      display: flex;
      flex-direction: column;
      font-size: 30px;
      margin-top: 50%;
      color: #fff;
      span {
        margin: 20px 0;
      }
    }
  }
  .animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
  @-webkit-keyframes tada {
    0% {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
    10%,
    20% {
      -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -1deg);
      transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -1deg);
    }
    30%,
    50%,
    70%,
    90% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 1deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 1deg);
    }
    40%,
    60%,
    80% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -1deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -1deg);
    }
    100% {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
  @keyframes tada {
    0% {
      -webkit-transform: scale3d(1, 1, 1);
      -ms-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
    10%,
    20% {
      -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -1deg);
      -ms-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -1deg);
      transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -1deg);
    }
    30%,
    50%,
    70%,
    90% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 1deg);
      -ms-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 1deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 1deg);
    }
    40%,
    60%,
    80% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -1deg);
      -ms-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -1deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -1deg);
    }
    100% {
      -webkit-transform: scale3d(1, 1, 1);
      -ms-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
  .download-button {
    -webkit-animation-name: tada;
    animation-name: tada;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    z-index: 998;
  }
}
</style>
